
import dust from "dustjs-linkedin";


(function(){dust.register("lessons/lesson-creator",body_0);function body_0(chk,ctx){return chk.write("<div class=\"lesson-creator\"><main><div class=\"editor\"></div></main></div><div class=\"container\"></div>");}return body_0;})();

export default 0;
